import React from 'react';
import MatClntCoreTransactionList from './MatClntCoreTransactionList';

export default function MatClntAssignmentList() {
  return (
    <MatClntCoreTransactionList
      title="Client Material - Assignment Transactions"
      opTypes={["assign"]}
    />
  );
}
